import { render, staticRenderFns } from "./edit-shop.vue?vue&type=template&id=02ba0880&scoped=true&"
import script from "./edit-shop.vue?vue&type=script&lang=js&"
export * from "./edit-shop.vue?vue&type=script&lang=js&"
import style0 from "./edit-shop.vue?vue&type=style&index=0&id=02ba0880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ba0880",
  null
  
)

export default component.exports